import { prefetchNewsPageData } from './hooks/useNews';

let modulePromise = null;
let pagePromise = null;

export function loadNewsIntelligenceModule() {
  if (!modulePromise) {
    modulePromise = import('./NewsModule').catch((error) => {
      modulePromise = null;
      throw error;
    });
  }
  return modulePromise;
}

export function preloadNewsIntelligencePage() {
  if (!pagePromise) {
    pagePromise = Promise.allSettled([
      loadNewsIntelligenceModule(),
      prefetchNewsPageData(),
    ]).finally(() => {
      pagePromise = null;
    });
  }
  return pagePromise;
}

export function scheduleNewsIntelligencePreload(delay = 300) {
  if (typeof window === 'undefined') return () => {};

  let cancelled = false;
  const run = () => {
    if (cancelled) return;
    preloadNewsIntelligencePage().catch(() => {});
  };

  if (typeof window.requestIdleCallback === 'function') {
    const id = window.requestIdleCallback(run, { timeout: 1500 });
    return () => {
      cancelled = true;
      window.cancelIdleCallback?.(id);
    };
  }

  const timer = window.setTimeout(run, delay);
  return () => {
    cancelled = true;
    window.clearTimeout(timer);
  };
}
